export default __webpack_public_path__ + "static/image-06-330x330-bef297879b94eb5c8612831d46aa0158.jpg";